export const createTreeCheckInitState = ({ checkedKeys, halfCheckedKeys }) => ({
  expandedKeys: new Set(),
  checkedKeys: new Set(checkedKeys || []),
  halfCheckedKeys: new Set(halfCheckedKeys || []),
  loadedKeys: new Set(),
});
